function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, formErrors) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['auth-banners'] = function({
      success,
      info,
      error
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((success) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-auth-banner-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-banner", {
              "attrs": __vjadeStringifyAttrsIfObj({
                id: `success-banner`,
                theme: `success`,
                size: `small`,
                type: `embedded`,
                'body-text': success,
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat((info) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-auth-banner-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-banner", {
              "attrs": __vjadeStringifyAttrsIfObj({
                id: `info-banner`,
                theme: `info`,
                size: `medium`,
                type: `embedded`,
                'body-text': info,
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat((error) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-auth-banner-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-banner", {
              "attrs": __vjadeStringifyAttrsIfObj({
                id: `error-banner`,
                theme: `warn`,
                size: `medium`,
                type: `embedded`,
                'body-text': error,
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['invisible-enter'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("input", {
          "attrs": __vjadeStringifyAttrsIfObj({
              type: `submit`,
              tabindex: -1 /* disable tab focus */
            }
            /* awful hack because some browsers disable Enter key submission when display: none */
          ),
          "style": {
            'position': `absolute`,
            'left': `-9999px`,
            'width': `1px`,
            'height': `1px`
          },
        }));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("auth-container", {
        "attrs": __vjadeStringifyAttrsIfObj({
          'show-footer-links': true,
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "attrs": __vjadeStringifyAttrsIfObj({
            slot: `auth-form-slot`
          }),
          "class": {
            'auth-form': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($attr(`valid`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['auth-banners'].call(this, {
              info: $attr(`message`),
              error: $helpers.getApiErrors()
            }));
            __jade_nodes = __jade_nodes.concat(h("form", {
              "attrs": __vjadeStringifyAttrsIfObj({
                action: `/reset-password/`,
                method: `post`,
              }),
              "hook": {
                insert: $helpers.onFormInserted,
              },
              "on": {
                submit: $helpers.handleSubmit,
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("h1", {
                "class": {
                  'auth-form-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Reset Password");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'auth-form-field-row': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-shadowless-input", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    'field-id': `id_password1`,
                    'field-name': `password1`,
                    'validation-status': formErrors.password ? `invalid` : ``,
                    'error-message': formErrors.password,
                    label: `New Password`,
                    type: `password`,
                  }),
                  "on": {
                    input: (ev) => $helpers.handlePasswordInput($helpers.FormField.Password, ev),
                    blur: $helpers.handlePasswordBlur,
                  },
                  "hook": {
                    insert: ({
                      elm
                    }) => elm.focus()
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'auth-form-field-row': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-shadowless-input", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    'field-id': `id_password2`,
                    'field-name': `password2`,
                    'validation-status': formErrors.confirm ? `invalid` : ``,
                    'error-message': formErrors.confirm,
                    label: `Re-enter Password`,
                    type: `password`,
                  }),
                  "on": {
                    input: (ev) => $helpers.handlePasswordInput($helpers.FormField.Confirm, ev),
                    blur: $helpers.handlePasswordBlur,
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("input", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  type: `hidden`,
                  name: `csrfmiddlewaretoken`,
                  value: $helpers.getCsrfToken()
                }),
              }));
              __jade_nodes = __jade_nodes.concat(jade_mixins['invisible-enter'].call(this));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'auth-form-field-row': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    theme: `primary`,
                  }),
                  "on": {
                    click: $helpers.handleSubmitClick,
                  },
                  "class": {
                    'save-password': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Save");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['auth-banners'].call(this, {
              error: "Sorry, we couldn't reset the password for this account. Please [contact support](https://help.mixpanel.com/hc/en-us/requests/new)."
            }));;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "formErrors" in locals ? locals.formErrors : typeof formErrors !== "undefined" ? formErrors : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;